import React from "react";
import { Navigate } from "react-router-dom";
import { useGrandmasterExperience } from "../../contexts/GrandmasterExperienceContext";

/**
 * Blocks new/uncommitted product surfaces for non-grandmaster hospitals.
 */
const RequireGrandmasterExperience: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isGrandmasterExperience, loading } = useGrandmasterExperience();

  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center text-sm text-gray-500">
        Loading…
      </div>
    );
  }

  if (!isGrandmasterExperience) {
    return <Navigate to="/hire" replace />;
  }

  return <>{children}</>;
};

export default RequireGrandmasterExperience;
